<script>
import globalView from '../../component/cdevs/partners/globalData.vue'
import buton from '../../component/helper/add/button'
import createPartners from '../../component/cdevs/partners/createPartners.vue'
import detailsPartners from '../../component/cdevs/partners/deailsPartners.vue'
import comingSoon from '../../component/cdevs/partners/comingSoon.vue'

export default {
  components: {
    // globalView,
    // // buton,
    // createPartners,
    // detailsPartners,
    comingSoon
  },
  data() {
    return {
      showGlobalView: true,
      showCreatePartner: false,
      showPartnerDetails: false,
      selectedPartner: null
    }
  },
  methods: {
    handleButtonClick() {
      this.showGlobalView = false;
      this.showCreatePartner = true;
    },
    handleBackButtonClick() {
      this.showCreatePartner = false;
      this.showGlobalView = true;
    },
    handlePartnerSelected(partner) {
      this.selectedPartner = partner;
      this.showGlobalView = false;
      this.showPartnerDetails = true;
    },
    handleBackFromDetails() {
      this.showPartnerDetails = false;
      this.showGlobalView = true;
    }
  }
}
</script>

<template>
  <div class="p-6 pr-6 all">
    <!-- Global View -->
    <div
      v-if="showGlobalView"
      class="p-6"
    >
      <div class="flex items-center">
        <div class="w-1/2 flex text-left text-c42 items-center font-c8 mb-5">
          SFD partenaires
        </div>


        <!-- <div class="w-1/2 flex justify-end">
          <buton
            label="Nouveau partenaire"
            class="w-2/5"
            size="18px"
            rounded="6px"
            weight="500"
            background="#312879"
            @click="handleButtonClick"
          />
        </div> -->
      </div>
      <div class="bg-white rounded-14">
        <div class="flex items-center justify-center h-screen">
          <comingSoon />
        </div>
      </div>
      <div>
        <!-- Passe la fonction de sélection -->
        <!-- <globalView @partnerSelected="handlePartnerSelected" /> -->
      </div>
    </div>

    <!-- <div v-if="showCreatePartner">
      <createPartners @handleBackButtonClick="handleBackButtonClick" />
    </div> -->

    <!-- Details Partner -->
    <!-- <div v-if="showPartnerDetails">
      <detailsPartners :partner="selectedPartner" @back="handleBackFromDetails" />
    </div> -->
  </div>
</template>

<style>
.all {
  min-height: 100vh;
}
</style>
